var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "baseInfoManage" },
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: {
            model: _vm.childData,
            rules: _vm.rules,
            inline: "",
            "label-position": "right",
            "label-width": "110px"
          }
        },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("table.areaGroupIdName"),
                prop: "upIdList"
              }
            },
            [
              _c("el-cascader", {
                staticClass: "form-item-width",
                attrs: {
                  clearable: "",
                  options: _vm.options,
                  props: _vm.propstree,
                  disabled: _vm.keyValue > 0
                },
                on: { change: _vm.getNode },
                model: {
                  value: _vm.childData.upIdList,
                  callback: function($$v) {
                    _vm.$set(_vm.childData, "upIdList", $$v)
                  },
                  expression: "childData.upIdList"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("table.advCode"), prop: "adCode" } },
            [
              _c("el-input", {
                staticClass: "form-item-width",
                attrs: {
                  clearable: "",
                  type: "text",
                  placeholder: "请填写广告位号"
                },
                model: {
                  value: _vm.childData.adCode,
                  callback: function($$v) {
                    _vm.$set(_vm.childData, "adCode", $$v)
                  },
                  expression: "childData.adCode"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("table.buildingFloor"), prop: "floor" } },
            [
              _c("el-input-number", {
                staticClass: "form-item-width",
                attrs: { clearable: "" },
                model: {
                  value: _vm.childData.floor,
                  callback: function($$v) {
                    _vm.$set(_vm.childData, "floor", $$v)
                  },
                  expression: "childData.floor"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("table.userState"), prop: "adStatus" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.childData.adStatus,
                    callback: function($$v) {
                      _vm.$set(_vm.childData, "adStatus", $$v)
                    },
                    expression: "childData.adStatus"
                  }
                },
                _vm._l(_vm.statueOption, function(item) {
                  return _c(
                    "el-radio",
                    {
                      key: item.value,
                      attrs: { label: parseInt(item.dicValue) }
                    },
                    [_vm._v(_vm._s(item.dicName))]
                  )
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("table.remark") } },
            [
              _c("el-input", {
                staticClass: "form-item-width",
                attrs: {
                  clearable: "",
                  placeholder: "请输入备注",
                  maxlength: "100",
                  type: "textarea",
                  autosize: { minRows: 3, maxRows: 3 }
                },
                model: {
                  value: _vm.childData.adRemark,
                  callback: function($$v) {
                    _vm.$set(_vm.childData, "adRemark", $$v)
                  },
                  expression: "childData.adRemark"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.handCancle } }, [
            _vm._v(_vm._s(_vm.$t("button.cancel")))
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handCreate } },
            [_vm._v(_vm._s(_vm.$t("button.confirm")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }